import { Autocomplete, Badge, Button, debounce, IconButton, MenuItem, TextField } from '@mui/material'
import logo from '../logo.svg'
import { Add, Menu as MenuIcon, PersonOutlineOutlined, ShoppingCartOutlined } from '@mui/icons-material'
import './NavBar.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useUser } from '../hooks'
import NewQuoteDialog from '../NewQuote/NewQuote'
import SideNav from './SideNav'
import { useImpresCart } from '../Catalogs/Impres/ImpresCartContext'
import axios from 'axios'
import { quoteType } from 'src/types'

export default function NavBar() {
  const location = useLocation()
  const user = useUser()
  const { itemCount, openDrawer } = useImpresCart()

  const [newQuoteOpen, setNewQuoteOpen] = useState(false)
  const [sideNavOpen, setSideNavOpen] = useState(false)

  useEffect(() => {
    setSideNavOpen(false)
  }, [location.pathname])

  return (
    <div className="nav-bar">
      <div className="nav-bar-left">
        <IconButton onClick={() => setSideNavOpen(true)} aria-label="Open navigation menu">
          <MenuIcon />
        </IconButton>
        <img src={logo} alt="logo" />
      </div>
      <SideNav open={sideNavOpen} onClose={() => setSideNavOpen(false)} />
      <div className="nav-bar-right">
        <IconButton onClick={openDrawer} aria-label="Open IMPRES catalog cart">
          <Badge badgeContent={itemCount} color="error">
            <ShoppingCartOutlined />
          </Badge>
        </IconButton>
        <div className="nav-bar-search-group">
          <GlobalSearch />
          <Button variant="contained" startIcon={<Add />} onClick={() => setNewQuoteOpen(true)} title="New Quote">
            <span className="nav-bar-btn-label nav-bar-truncate-label">New Quote</span>
          </Button>
          <NewQuoteDialog open={newQuoteOpen} onClose={() => setNewQuoteOpen(false)} />
        </div>
        <Button disabled startIcon={<PersonOutlineOutlined />} title={user.displayName ?? undefined}>
          <span className="nav-bar-btn-label nav-bar-truncate-label">{user.displayName}</span>
        </Button>
      </div>
    </div>
  )
}

function GlobalSearch() {
  const navigate = useNavigate()
  const user = useUser()
  const [globalSearchResults, setGlobalSearchResults] = useState<{ id: string; label: string }[]>([])

  const debouncedSearch = debounce((query: string) => {
    axios
      .get('/quote', {
        params: { quoteNumber: query, owner: !user.role.admin && !user.role.operations ? user.email : undefined },
      })
      .then(res => {
        setGlobalSearchResults(
          res.data.list.map((quote: quoteType) => ({ id: quote.QuoteId, label: `${quote.QuoteNumber}` })),
        )
      })
      .catch(err => {
        console.error(err)
      })
  }, 500)

  return (
    <Autocomplete
      fullWidth
      freeSolo
      filterOptions={x => x}
      size="small"
      noOptionsText="No results"
      options={globalSearchResults}
      renderOption={(props, option) => (
        <MenuItem {...props} key={option.id}>
          {option.label}
        </MenuItem>
      )}
      renderInput={params => <TextField {...params} label="Search" />}
      onInputChange={(_, value) => {
        debouncedSearch(value)
      }}
      onChange={(_, value) => {
        if (typeof value !== 'string' && value && value.id) {
          navigate(`/quote/${value.id}`)
          setGlobalSearchResults([])
        }
      }}
    />
  )
}
